// v1.9.30 — subscribe a page's own load() to the top-bar refresh button.
// Usage:  useAppRefresh(load);
// The header dispatches window 'app-refresh'; every page that opts in with
// this hook re-runs its handler. Pages that don't opt in are unaffected —
// the button still spins for the tactile feedback but no fetch happens
// for them (user can still hit browser F5 as before).
import { useEffect } from 'react';

export default function useAppRefresh(handler) {
  useEffect(() => {
    if (typeof handler !== 'function') return undefined;
    const h = () => { try { handler(); } catch (_) {} };
    window.addEventListener('app-refresh', h);
    return () => window.removeEventListener('app-refresh', h);
  }, [handler]);
}
